import { useState } from 'react';
export const useSegmentDetails = () => {
  const [detailsSegment, setDetailsSegment] = useState();
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const openDetails = segment => {
    setDetailsSegment(segment);
    setIsDetailsOpen(true);
  };
  return {
    detailsSegment,
    isDetailsOpen,
    openDetails,
    closeDetails: () => setIsDetailsOpen(false)
  };
};
//# sourceMappingURL=useSegmentDetails.js.map